import { all } from "redux-saga/effects";
import {
  acqSrcListWatcher,
  adminRolesWatcher,
  bnkNameListWatcher,
  buisnessTypeListWatcher,
  binLocationListWatcher,
  catListWatcher,
  customerListWatcher,
  departmentListWatcher,
  disCusGrpListWatcher,
  disCusCatListWatcher,
  disCusListWatcher,
  doctorListWatcher,
  imageUploadWatcher,
  itemGroupListWatcher,
  itemTypeListWatcher,
  manufacturesListWatcher,
  paymentMethodListWatcher,
  tableAlertWatcher,
  columnAlertWatcher,
  phoneListWatcher,
  pincodeListWatcher,
  priceListWatcher,
  productDetailsWatcher,
  productListWatcher,
  rolesListWatcher,
  attachedRolesDepartmentListWatcher,
  schListWatcher,
  sectorListWatcher,
  shippingTypeListWatcher,
  stateListWatcher,
  storeIdWatcher,
  taxCatListWatcher,
  interTaxCatListWatcher,
  transactionPrintWatcher,
  transactionShareWatcher,
  uomGroupFindOneWatcher,
  uomGroupListWatcher,
  uomListWatcher,
  usersListWatcher,
  allUsersListWatcher,
  valListWatcher,
  vendorListWatcher,
  wareHouseListWatcher,
  cusTypeListWatcher,
  storeListWatcher,
  docListWatcher,
  adminRolesModWatcher,
  productBatchDetailsWatcher,
  storeStateListWatcher,
  storesItemWatcher,
  storeSearchWatcher,
  storeCityListWatcher,
  storeDistrictListWatcher,
  getAddrssWatcher,
  newWareHouseListWatcher,
  disCusTypeListWatcher,
} from "../general-saga";

export default function* generalRootSaga() {
  yield all([
    getAddrssWatcher(),
    productListWatcher(),
    phoneListWatcher(),
    stateListWatcher(),
    storeStateListWatcher(),
    storeDistrictListWatcher(),
    storeCityListWatcher(),
    storeSearchWatcher(),
    storesItemWatcher(),
    doctorListWatcher(),
    storeIdWatcher(),
    paymentMethodListWatcher(),
    tableAlertWatcher(),
    columnAlertWatcher(),
    catListWatcher(),
    uomListWatcher(),
    priceListWatcher(),
    itemGroupListWatcher(),
    taxCatListWatcher(),
    manufacturesListWatcher(),
    shippingTypeListWatcher(),
    sectorListWatcher(),
    schListWatcher(),
    valListWatcher(),
    vendorListWatcher(),
    uomGroupListWatcher(),
    uomGroupFindOneWatcher(),
    imageUploadWatcher(),
    adminRolesWatcher(),
    adminRolesModWatcher(),
    rolesListWatcher(),
    attachedRolesDepartmentListWatcher(),
    docListWatcher(),
    departmentListWatcher(),
    usersListWatcher(),
    allUsersListWatcher(),
    cusTypeListWatcher(),
    acqSrcListWatcher(),
    buisnessTypeListWatcher(),
    bnkNameListWatcher(),
    disCusListWatcher(),
    disCusGrpListWatcher(),
    disCusCatListWatcher(),
    disCusTypeListWatcher(),
    customerListWatcher(),
    pincodeListWatcher(),
    binLocationListWatcher(),
    wareHouseListWatcher(),
    newWareHouseListWatcher(),
    itemTypeListWatcher(),
    transactionShareWatcher(),
    transactionPrintWatcher(),
    storeListWatcher(),
    productDetailsWatcher(),
    productBatchDetailsWatcher(),
    interTaxCatListWatcher()
  ]);
}
